import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { GetAmendRsvpFormContentModel } from '../plan-amend-helper';
import { RsvpAdoptionDetailsWizard } from './rsvp-adoption-details-wizard';

export class RsvpAmendDetailsWizard extends RsvpAdoptionDetailsWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendRsvpFormContentModel(content, institutionSettings);

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.RsvpAmendDetail,            
            pageTitle: institutionSettings?.amendRSVPDetailsTitle,
            PageDescription: institutionSettings?.amendRSVPDetailsDescription,
        };
    }
}